import { V2_TYPE } from './helperV2';

export const DOCUMENT_FIRST_ENABLED = true;

export const isDocumentFirst = ({ applicationForm, isBrokerMode, v2Type } = {}) => {
    if (!DOCUMENT_FIRST_ENABLED) return false;
    if (!isBrokerMode) return false;
    if (v2Type !== undefined && v2Type !== V2_TYPE.PLUS) return false;
    return Number(applicationForm?.formVersion) >= 2;
};

export default isDocumentFirst;

